<template lang="pug">
  .theader
    .th(v-for="{label, nonClickable, sellTitle, field}, i in labels",
    :class="[{sorted: field === sortedBy.field}, sellTitle]", :key="i",
    @click="sortingByLabel(field, nonClickable)")
      lei-popover(:text="getTip(label)")
        label.th-label.default-bold.w-6 {{label}}
        font-awesome-icon.icon(
        v-if="!nonClickable",
        :icon="sortedBy.desc && field === sortedBy.field ? 'caret-up': 'caret-down'")
</template>
<script>
import { mapMutations, mapState, } from 'vuex'
import { SET_SORTING_BY, } from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import LeiPopover from '../lei-components/LeiPopover'
import simple from '../../constants/tooltips/simple'

export default {
  components: { LeiPopover, },
  mixins: [ routerSearch, ],
  data () {
    return {
      tooltips: simple,
      labels: [
        {
          sellTitle: 'country',
          field: 'entity.legalAddress.country',
          label: 'Country',
        },
        {
          sellTitle: 'entity-status',
          field: 'entity.status',
          label: 'Entity Status',
        },
        {
          sellTitle: 'legal-name',
          field: 'entity.legalName',
          label: 'Legal name',
        },
        {
          sellTitle: 'lei',
          field: 'lei',
          label: 'LEI',
        },
        {
          sellTitle: 'reg-status',
          field: 'registration.status',
          label: 'Reg. Status',
        },
        // {
        //   sellTitle: 'selection',
        //   field: 'selection',
        //   label: 'Selection',
        //   nonClickable: true
        // }
      ],
    }
  },
  computed: {
    ...mapState('search', [ 'sortedBy', ]),
  },
  methods: {
    sortingByLabel (field, nonClickable) {
      if (nonClickable) return
      this.setSortingBy(field)
      this.routerSearch('#results-section')
    },
    getTip (title) {
      if (title === 'Selection') {
        return this.tooltips.searchResultsColumnHeading
      }
    },

    ...mapMutations('search', { setSortingBy: SET_SORTING_BY, }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  #result-list
    .theader
      display flex
      justify-content space-between
      border-top 5px solid $default-color-light-2
      border-bottom 2px solid $default-color-light-1
      .th
        padding 15px
        height 50px
        display flex
        align-items center
        cursor pointer
        .th-label
          cursor pointer
        &.sorted
          .th-label
            color $turquoise-color
          .icon
            color $turquoise-color
        &.selection
          justify-content flex-end
        .icon
          font-size 1.2rem
          margin-left 6px

    @media screen and (max-width: $laptop-l) and (min-width: $laptop)
      .theader
        font-size 90%

    @media screen and (max-width: $laptop)
      .theader
        display none

</style>



// WEBPACK FOOTER //
// src/components/data-table/THeader.vue